import { createSlice } from "@reduxjs/toolkit";

const prosureSlice = createSlice({
  name: "prosure",
  initialState: {
    formDetail: {},
    otpVerified: false,
    paymentData: {},
    prosureUserId: null,
    otpDone: false,
    successUpdate: false,
    failedUpdate: false,
    transactionTimer: 20000,
  },
  reducers: {
    updateFormDetail: (state, action) => {
      state.formDetail = action.payload;
    },
    updateVerified: (state, action) => {
      state.otpVerified = action.payload;
    },
    updatePayment: (state, action) => {
      state.paymentData = action.payload;
    },
    updateProsureId: (state, action) => {
      state.prosureUserId = action.payload;
    },
    updateOTPDone: (state, action) => {
      state.otpDone = action.payload;
    },
    updateSuccess: (state, action) => {
      state.successUpdate = action.payload;
    },
    updateFailed: (state, action) => {
      state.failedUpdate = action.payload;
    },
    updateTransactionTimer: (state, action) => {
      state.transactionTimer = action.payload;
    },
    resetDetail: (state, action) => {
      state.formDetail = {};
      state.otpVerified = false;
      state.paymentData = {};
      state.prosureUserId = null;
      state.otpDone = false;
      state.failedUpdate = false;
      state.successUpdate = false;
      state.transactionTimer = 20000
    },
  },
});

const { reducer } = prosureSlice;
const selectorprosure = (state: any) => state.prosure;
const { updateFormDetail, resetDetail, updateVerified, updatePayment, updateProsureId, updateOTPDone, updateSuccess, updateFailed, updateTransactionTimer } =
  prosureSlice.actions;
export {
  updateFormDetail,
  resetDetail,
  updateVerified,
  updatePayment,
  updateProsureId,
  updateOTPDone,
  updateSuccess,
  updateFailed,
  updateTransactionTimer,
  selectorprosure,
};

export default reducer;
